export default __webpack_public_path__ + "static/media/DateSelection.41b87502.svg";